import { constants } from '@airtm/utils';

const { USA_AND_TERRITORIES } = constants;
export default (user: { country: string } & { [key: string]: any }) => {
  const { country } = user;

  return !['ARG', ...USA_AND_TERRITORIES].includes(country);
};
